import { DateTime } from 'luxon';
export function timeStampTo24HourEST(timeStamp) {
  const date = DateTime.fromMillis(Number(timeStamp))
    .setZone('America/New_York')
    .toFormat('HH:mm:ss');
  return date;
}
